<script setup lang="ts">
import { computed } from "vue";
import { useTranslation } from "i18next-vue";
import DRBtn from "../DRBtn.vue";

const { t } = useTranslation();

const props = withDefaults(
  defineProps<{
    modelValue: boolean;
    title: string;
    hideFooter?: boolean;
    width?: string | number;
    cancelLabel?: string;
    confirmLabel?: string;
    leftBtn?: boolean;
    leftBtnLabel?: string;
    showConfirm?: boolean;
  }>(),
  {
    hideFooter: false,
    width: 500,
    leftBtn: false,
    showConfirm: true,
  }
);

const resolvedCancelLabel = computed(() => props.cancelLabel ?? t("cancel"));
const resolvedConfirmLabel = computed(() => props.confirmLabel ?? t("confirm"));
const resolvedLeftBtnLabel = computed(() => props.leftBtnLabel ?? t("delete"));

const emit = defineEmits<{
  (e: "update:modelValue", value: boolean): void;
  (e: "cancel"): void;
  (e: "confirm"): void;
  (e: "delete"): void;
}>();

const show = computed({
  get: () => props.modelValue,
  set: (value: boolean) => emit("update:modelValue", value),
});

const cancel = () => {
  emit("cancel");
  show.value = false;
};

const confirm = () => {
  emit("confirm");
};

const onDelete = () => {
  emit("delete");
};
</script>

<template>
  <el-dialog
    v-model="show"
    :title="title"
    :width="width"
    append-to-body
    style="max-width: 95vw"
    align-center
  >
    <slot></slot>
    <template v-if="!hideFooter" #footer>
      <div class="w-100 d-flex justify-content-between align-items-center">
        <div>
          <DRBtn
            v-if="leftBtn"
            variant="danger"
            :label="resolvedLeftBtnLabel"
            @click="onDelete"
          ></DRBtn>
        </div>
        <div class="dialog-footer d-flex justify-content-end gap-2">
          <DRBtn
            :label="resolvedCancelLabel"
            variant="outline"
            @click="cancel"
          ></DRBtn>
          <DRBtn
            v-if="showConfirm"
            :label="resolvedConfirmLabel"
            @click="confirm"
          ></DRBtn>
        </div>
      </div>
    </template>
  </el-dialog>
</template>

<style lang="scss" scoped></style>
